import React from 'react';

interface ShowProps {
    when: boolean;
    fallback?: React.ReactNode;
    children: React.ReactNode;
}

const Show: React.FC<ShowProps> = ({ when, children, fallback = null }) => {
    return (
        <>
            {(when) ? children : fallback}   
        </>
    );
};

export default Show;